import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.number.constructor.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue";
var _hoisted_1 = {
  class: "base-empty-body"
};
var _hoisted_2 = {
  class: "tip"
};
var _hoisted_3 = {
  key: 0
};
var _hoisted_4 = ["src"];
import { validateNull } from '@/util/validate.js';
import { useRouter } from 'vue-router';
export default {
  __name: 'BaseEmpty',
  props: {
    type: {
      type: [Number, String],
      default: 0
    },
    title: {
      type: String,
      default: '暂无内容'
    },
    showFooter: {
      type: Boolean,
      default: true
    }
  },
  setup: function setup(__props) {
    var rightEnter = require('@/assets/home/double.svg');
    var router = useRouter();
    var typeData = [{
      name: '教学',
      title: '暂无内容',
      location: '课堂报告',
      behavior: null,
      alias: 'classReports'
    }, {
      name: '创作',
      title: '暂无内容',
      location: '创作中心',
      behavior: '创作',
      alias: 'inspirationCentre'
    }, {
      name: '相册',
      title: '暂无内容',
      location: '班级相册',
      behavior: null,
      alias: 'classPhoto'
    }, {
      name: '活动',
      title: '暂无内容',
      location: '活动广场',
      behavior: '参与活动',
      alias: 'activity'
    }, {
      name: '笔记',
      title: '暂无内容',
      location: '笔记',
      behavior: '记下你的灵感',
      alias: 'cloudNotes'
    }];
    var props = __props;

    /**
     * @description: 跳转
     * @param {*} item
     * @return {*}
     */
    var navigateTo = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(item) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              // 0 创作 1 相册 2 活动
              if (item.alias === 'inspirationCentre') {
                router.push('/inspirationCentre');
              } else if (item.alias === 'classPhoto') {
                router.push('/classPhoto');
              } else if (item.alias === 'activity') {
                router.push('/activity');
              }
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function navigateTo(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("p", null, _toDisplayString(__props.title || typeData[__props.type].title), 1), __props.showFooter ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "empyt-footer",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return navigateTo(typeData[__props.type]);
        })
      }, [_cache[1] || (_cache[1] = _createTextVNode(" 点击前往- ", -1)), _createElementVNode("span", _hoisted_2, _toDisplayString(typeData[__props.type].location), 1), !_unref(validateNull)(typeData[__props.type].behavior) ? (_openBlock(), _createElementBlock("span", _hoisted_3, " -" + _toDisplayString(typeData[__props.type].behavior), 1)) : _createCommentVNode("", true), _createElementVNode("img", {
        class: "right_icon",
        src: _unref(rightEnter),
        alt: ""
      }, null, 8, _hoisted_4)])) : _createCommentVNode("", true)]);
    };
  }
};